import React from 'react'
import { Table } from 'antd'

import Loading from '../../../components/Loaders/Loading'
import { paginationItemRender } from '../../../utils/table'
import { AppContext } from '../../../AppContext'

import { createInternalKeysCollectionColumns, fetchCollection } from '../utils'

import InternalKeyDeleteModal from './DeleteModal'
import InternalKeyUpdateModal from './UpdateModal'
import InternalKeyDetailsModal from './DetailsModal'

function InternalKeysSection (props) {
  const {
    params,
    setParams,
    city,
    refetchCollection,
    triggerRefetchCollection,
    setTotalLoading,
    setTotalCount
  } = props

  const profile = React.useContext(AppContext).profile || {}

  const [loading, setLoading] = React.useState(true)
  const [page, setPage] = React.useState(1)
  const [total, setTotal] = React.useState(0)
  const [data, setData] = React.useState([])
  const [selectedKeyId, setSelectedKeyId] = React.useState('')
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false)
  const [editModalOpen, setEditModalOpen] = React.useState(false)
  const [detailsModalOpen, setDetailsModalOpen] = React.useState(false)
  const [activeKeyIds, setActiveKeyIds] = React.useState([])

  const selectedKey = React.useMemo(
    () => data.find(item => item._id === selectedKeyId),
    [data, selectedKeyId]
  )

  const fetchLockBoxCollection = signal => {
    fetchCollection(
      { city, page, ...params },
      signal,
      setData,
      setTotal,
      setLoading,
      setTotalCount,
      setTotalLoading,
      'getInternalKeysCollection',
    )
  }

  React.useEffect(() => {
    const controller = new AbortController()

    fetchLockBoxCollection(controller.signal)

    return () => {
      controller.abort()
    }
  }, [
    city,
    page,
    refetchCollection,
    params,
  ])

  return (
    <div className="pt-7">
      {loading
        ? <Loading/>
        : (
          <div>
            <Table
              loading={loading}
              dataSource={data}
              columns={createInternalKeysCollectionColumns(
                setSelectedKeyId, setEditModalOpen, setDeleteModalOpen,
                setDetailsModalOpen, triggerRefetchCollection, profile,
                activeKeyIds, setActiveKeyIds
              )}
              scroll={{ x: 1500 }}
              sticky={{ offsetHeader: 45 }}
              pagination={{
                current: page,
                pageSize: params.pageSize,
                total,
                showSizeChanger: true,
                itemRender: paginationItemRender,
                onChange: (nextPage, nextLimit) => {
                  if (nextPage !== page) {
                    setPage(nextPage)
                  }

                  if (nextLimit !== params.pageSize) {
                    setPage(1)
                    setParams(prev => ({ ...prev, pageSize: nextLimit }))
                  }
                }
              }}
              rowKey="_id"
            />

            <InternalKeyDetailsModal
              canUpdate={profile?.isAdmin || profile?.updateInternalKeyStatus}
              canDelete={profile?.isAdmin || profile?.deleteInternalKey}
              canReadCode={profile?.isAdmin || profile?.readInternalKeyCode}
              open={!!selectedKeyId && !!selectedKey && detailsModalOpen}
              onClose={() => {
                setSelectedKeyId('')
                setDetailsModalOpen(false)
              }}
              handleDeleteModalOpen={() => setDeleteModalOpen(true)}
              triggerCollectionRefetch={triggerRefetchCollection}
              internalKey={selectedKey}
            />

            {(profile?.isAdmin || profile?.updateInternalKey) && (
              <InternalKeyUpdateModal
                open={!!selectedKeyId && !!selectedKey && editModalOpen}
                onClose={() => {
                  setSelectedKeyId('')
                  setEditModalOpen(false)
                }}
                triggerCollectionRefetch={triggerRefetchCollection}
                internalKey={selectedKey}
              />
            )}

            {(profile?.isAdmin || profile?.deleteInternalKey) && (
              <InternalKeyDeleteModal
                open={!!selectedKeyId && !!selectedKey && deleteModalOpen}
                onClose={() => {
                  if (!detailsModalOpen) {
                    setSelectedKeyId('')
                  }
                  setDeleteModalOpen(false)
                }}
                triggerCollectionRefetch={triggerRefetchCollection}
                internalKey={selectedKey}
              />
            )}
          </div>
        )}
    </div>
  )
}

export default InternalKeysSection
